import { render, staticRenderFns } from "./transfer_lead_form_history.vue?vue&type=template&id=131a4e05"
import script from "./transfer_lead_form_history.vue?vue&type=script&lang=js"
export * from "./transfer_lead_form_history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports